module.exports = __webpack_public_path__ + "media/images/photo/Residential/slider2-e78d568b483e667f1f38d2864d865714.png";